module.exports = __webpack_public_path__ + "static/media/applications-icon.bff08877.svg";